import { render } from "./EventsListTable.vue?vue&type=template&id=3e6008a8"
import script from "./EventsListTable.vue?vue&type=script&lang=js"
export * from "./EventsListTable.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2531651810/src/givergy_presenter_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__